import { FC, useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import useThread from '@/hooks/use-thread.hook';
import Tile from '.';
import AgentBadge from '@/components/agent-badge';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { BaseTileProps } from './helpers';

const AgentTile: FC<BaseTileProps> = (props) => {
  const {
    tile: { resourceId },
  } = props;
  const { agents } = useUserSettings();

  const agent = useMemo(() => {
    return agents.find(({ id }) => id === resourceId);
  }, [agents, resourceId]);

  const title = agent?.portal?.badge?.title || 'Assistant';
  const ImageEl = <AgentBadge agent={agent} />;

  const { loadThread } = useThread();
  const navigate = useNavigate();

  const handleClick = () => {
    loadThread(undefined, agent?.id);
    navigate({ to: '/chat' });
  };

  return <Tile onClick={handleClick} title={title} icon={ImageEl} {...props} />;
};

export default AgentTile;
